import styled from 'styled-components';
export const Container = styled.div `
  background-color: #f8edfb;
  color: #813399;
  display: flex;
  gap: 24px;
  padding: 12px 16px;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;
